import React from 'react'
import './Contactus.css'

function ContactUs() {
  return (
    <>
        <h3 className='form__title'>Get In Touch With Us</h3>
        <div className="container">
            <form>
                <ul>
                    <li>
                        <label for="name"><span>Name <span className="required-star">*</span></span></label>
                        <input type="email" id="mail" name="user_email" />
                    </li>
                    <li>
                        <label for="mail"><span>Email <span className="required-star">*</span></span></label>
                        <input type="email" id="mail" name="user_email" />
                    </li>
                    <li>
                        <label for="msg"><span>Message</span></label>
                        <textarea rows="4" cols="50"></textarea>
                    </li>
                    <li>
                        <input type="submit" />
                    </li>
                </ul>
            </form>
        </div>
    </>
  )
}

export default ContactUs
